import React from 'react';
import './Button.scss';
import { Link } from 'react-router-dom';

type BackButtonProps = {
  target?: string | undefined;
  text?: string | undefined;
};

const BackButton: React.FC<BackButtonProps> = ({ target, text }) => {
  return (
    <Link to={target ?? '/'} className="back-link action-link">
      {'<'} {text || 'Back'}
    </Link>
  );
};

export default BackButton;
